import React, { useState } from "react";
import InputField from "../inputField/InputField";
import CustomSelector from "../selector/CustomSelector";

function HelpCenterSupport() {
  const [name, setName] = useState("");

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleSelectChange = (option) => {
    console.log(option);
  };

  const options = [
    { value: "24h", label: "24 Hours" },
    { value: "7d", label: "7 Days" },
    { value: "30d", label: "30 Days" },
    { value: "1y", label: "1 Year" },
    { value: "all", label: "All Time" },
  ];

  return (
    <div className="my_account mt-4">
      <div className="tabs_card">
        <div className="content">
          <form className="input_group mt-0">
            <div className="selector">
              <label>Select issue type</label>
              <CustomSelector options={options} onSelect={handleSelectChange} selectedText="select"/>
            </div>
            <InputField
              label="Email"
              value={name}
              onChange={handleNameChange}
            />
            <textarea className="textarea" placeholder="Write your issue" />
          </form>
        </div>
      </div>
    </div>
  );
}

export default HelpCenterSupport;
